import { gql } from '@apollo/client';

export const BULK_UPDATE_ENTITY_CRITICALITY_MUTATION = gql`
  mutation BulkUpdateEntityCriticalityOperation(
    $entityIds: [ID!]!
    $criticality: String
  ) {
    bulkUpdateEntityCriticality(
      entityIds: $entityIds
      criticality: $criticality
    ) {
      data {
        id
        criticality
      }
    }
  }
`;
